export const routeUrlObj = {
	"addanki-north": "addanki",
	"athirampattinam": "adirampattinam",
	"ahmadnagar": "ahmednagar",
	"ajanta-aurangabad": "ajanta",
	"ajmer-ajmer": "ajmer",
	"akola-buldhana": "buldhana",
	"aminagad": "amingad",
	"anugul": "angul",
	"ankolwadi": "ankolvadi",
	"arrah-bihar": "arrah",
	"ashti-beed": "ashti",
	"balapur-akola": "balapur",
	"bhoganipur": "bhognipur",
	"brahmapur-orissa": "brahmapur",
	"bramhapuri-chandrapur": "brahmapuri",
	"budaun": "badaun",
	"dechhu": "dechu",
	"deoria-uttar-pradesh": "deoria",
	"dharmapuri-tamil-nadu": "dharmapuri",
	"digras-yavatmal": "digras",
	"dindivanam": "tindivanam",
	"elayankudi": "ilayangudi",
	"gangakhed-parbhani": "gangakhed",
	"gobichettipalaiyam": "gobichettipalayam",
	"guntur-andhra-pradesh": "guntur",
	"haladi": "halady",
	"jahanabad-bihar": "jehanabad",
	"kadaiyanallur": "kadayanallur",
	"kaduthuruthi": "kaduthuruthy",
	"kasal-sindhudurg": "kasal",
	"kasegaon-sangli": "kasegaon",
	"kudush": "kudus",
	"kukke": "kukke-subramanya",
	"mahua-rajasthan": "mahua",
	"mahuva-gujarat": "mahuva",
	"manaparai": "manapparai",
	"mangrul-pir": "mangrulpir",
	"amalner-jalgaon": "amalner",
	"ambala-haryana": "ambala",
	"amritsar-punjab": "amritsar",
	"araria-court": "araria",
	"authoor-north-tamil-nadu": "authoor-north",
	"bhagha-purana": "bagha-purana",
	"bagodra": "bagodara",
	"bagra-rajasthan": "bagra",
	"balesar-satan": "balesar",
	"banda-maharashtra": "banda",
	"bhabhar-nava": "bhabhar",
	"bhubaneshwar": "bhubaneswar",
	"bina-etawa": "bina",
	"mundra-gujarat": "mundra",
	"munirabad-project-area": "munirabad",
	"murudeshwar": "murdeshwar",
	"nabarangpur": "nowrangpur",
	"nagar-kanpur-uttar-pradesh": "kanpur",
	"nagore-tamil-nadu": "nagore",
	"naigaon-nanded": "naigaon",
	"nalajerlla": "nallajerla",
	"naldurg-osmanabad": "naldurg",
	"nandura-buldhana": "nandura",
	"nanduri-nashik": "nanduri",
	"nardana": "nardane",
	"nawapur": "navapur",
	"nazareth": "nazerath",
	"numaligarh-refinery-township": "numaligarh",
	"okha-port": "okha",
	"orathanadu-mukthambalpuram": "orathanadu",
	"ottappalam": "ottapalam",
	"padadhri": "paddhari",
	"palacole": "palakollu",
	"pandarkavda": "pandharkaoda",
	"panaji": "panjim",
	"patoda-beed": "patoda",
	"pipariya-madhya-pradesh": "pipariya",
	"pondicherry-puducherry": "pondicherry",
	"puducherry": "pondicherry",
	"ponamaravathi": "ponnamaravathi",
	"pullampet": "pullampeta",
	"punjaipuliampatti": "punjai-puliyampatti",
	"puttur-karnataka": "puttur",
	"rae-bareli": "raebareli",
	"raipur-chhattisgarh": "raipur",
	"raisen-madhya-pradesh": "raisen",
	"muzaffarpur-bihar": "muzaffarpur",
	"padukkapathu-tuticorin": "padukkapathu",
	"murud-raigad": "murud",
	"palghar-thane": "palghar",
	"parola-jalgaon": "parola",
	"patna-bihar": "patna",
	"prathipadu-guntur": "prathipadu",
	"rajanagaram-andhra-pradesh": "rajanagaram",
	"chhapra-bihar": "chapra",
	"chhapra": "chapra",
	"chhaigaon-makhan": "chhegaon-makhan",
	"chittoor-andhra-pradesh": "chittoor",
	"coimbatore-tamil-nadu": "coimbatore",
	"darbhanga-bihar": "darbhanga",
	"disa": "deesa",
	"devli": "deoli",
	"devarkulam-a": "devarkulam",
	"dhoki-maharashtra": "dhoki",
	"digha-west-bengal": "digha",
	"dondaicha-warwade": "dondaicha",
	"dongaon-buldhana": "dongaon",
	"durg-bhilai": "durg",
	"durgapur-west-bengal": "durgapur",
	"dwarka-gujarat": "dwarka",
	"faizabad-uttar-pradesh": "faizabad",
	"firozabad-uttar-pradesh": "firozabad",
	"gandhinagar-gujarat": "gandhinagar",
	"gangavathi-karnataka": "gangavathi",
	"ghodegaon-pune": "ghodegaon",
	"gorakhpur-uttar-pradesh": "gorakhpur",
	"gurugram-gurgaon": "gurgaon",
	"gurgaon-haryana": "gurgaon",
	"hajipur-bihar": "hajipur",
	"hosnagar": "hosanagara",
	"hosangadi-karnataka": "hosangadi",
	"hyderabad-telangana": "hyderabad",
	"itanagar-arunachal-pradesh": "itanagar",
	"jedcharla": "jadcherla",
	"jaipur-rajasthan": "jaipur",
	"jammu-j-and-k": "jammu",
	"jarhi-chhattisgarh": "jarhi",
	"jaysingpur-kolhapur": "jaysingpur",
	"jetpur-navagadh": "jetpur",
	"jetpur-navagadh-gujarat": "jetpur",
	"jodhpur-rajasthan": "jodhpur",
	"kapu": "kapurthala",
	"kathmandu-central": "kathmandu",
	"kattipudi": "kathipudi",
	"katra-jammu-and-kashmir": "katra",
	"kayamkulam-kerala": "kayamkulam",
	"khal-khurd": "khalghat",
	"kherwara-chhaoni": "kherwara",
	"kollipara-andhra-pradesh": "kollipara",
	"korukolu": "korukollu",
	"kottayam-kerala": "kottayam",
	"kumily-kerala": "kumily",
	"kushalgarh-rajasthan": "kushalgarh",
	"lathi-gujarat": "lathi",
	"ramnagara-karnataka": "ramanagara",
	"ranchi-jharkhand": "ranchi",
	"roorkee-uttarakhand": "roorkee",
	"rudrapur-uttarakhand": "rudrapur",
	"sanavat-madhya-pradesh": "sanawad",
	"sangola-solapur": "sangole",
	"saquelim": "sanquelim",
	"sarangpur-madhya-pradesh": "sarangpur",
	"sawantwadi-sindhudurg": "sawantwadi",
	"seoni-madhya-pradesh": "seoni",
	"shahjahanpur-uttar-pradesh": "shahjahanpur",
	"shahpura-rajasthan": "shahpura",
	"shegaon-buldhana": "shegaon",
	"shelu-khadse": "shelu-bazar",
	"shivamogga": "shimoga",
	"shrirampur-ahmednagar": "shrirampur",
	"siddapur-sirsi-road-karnataka": "siddapur-sirsi-road",
	"sidhpur-gujarat": "sidhpur",
	"silchar-assam": "silchar",
	"sirhind-fatehgarh-sahib": "sirhind",
	"sivagiri-tirunelveli": "sivagiri",
	"sonkhed-nanded": "sonkhed",
	"ganganagar": "sri-ganganagar",
	"ganganagar-sri-ganganagar": "sri-ganganagar",
	"srikalahasthi": "srikalahasti",
	"sujanpur-himachal-pradesh": "sujanpur",
	"surat-gujarat": "surat",
	"suryapet-telangana": "suryapet",
	"talegaon-wardha": "talegaon",
	"talode": "taloda",
	"tara": "tarapur",
	"temburni": "tembhurni",
	"tirumangalam": "thirumangalam",
	"thodupuzha-kerala": "thodupuzha",
	"tiruchengodu": "tiruchengode",
	"tiruchirapalli": "tiruchirappalli",
	"tiruchirappalli-trichy": "tiruchirappalli",
	"tiruchirappalli-trichy-tamil-nadu": "tiruchirappalli",
	"tirunelveli-tamil-nadu": "tirunelveli",
	"tirupattur-vellore": "tirupattur",
	"thiruvannamalai": "tiruvannamalai",
	"tuticorin": "thoothukudi",
	"tuticorin-thoothukudi": "thoothukudi",
	"tuticorin-tamil-nadu": "thoothukudi",
	"udankudi": "udangudi",
	"udumalpet": "udumalaipettai",
	"udupi-karnataka": "udupi",
	"umarkhed-yavatmal": "umarkhed",
	"unguturu-andhra-pradesh": "unguturu",
	"vada": "vadalur",
	"vani": "vaniyambadi",
	"vanthali": "vanthli",
	"watar": "vathar",
	"veeravasaram-andhra-pradesh": "veeravasaram",
	"venkatapuram-telangana": "venkatapuram",
	"vijjeshwaram": "vijjeswaram",
	"virudhnagar": "virudhunagar",
	"virudunagar": "virudhunagar",
	"waluj-bk": "waluj",
	"yadur-shimoga": "yadur",
	"uran-islampur": "islampur",
	"sakri-maharashtra": "sakri",
	"gargoti-kolhapur": "gargoti",
	"attur-salem": "attur",
	"maliya-gujarat": "maliya",
	"courtalam": "courtallam",
	"dholera-gujarat": "dholera",
	"alangulam-tirunelveli": "alangulam",
	"armoor": "armur",
	"duggiralla": "duggirala",
	"shivpuri-uttar-pradesh": "shivpuri",
	"duliajan": "duliagaon",
	"tirupur": "tiruppur",
	"nagaon-assam": "nagaon",
	"kadiyam": "kadiam",
	"alangudi-pudhukottai": "alangudi",
	"kariyapatti": "kariapatti",
	"baleshwar": "balasore",
	"cuddapah": "kadapa",
	"cuddapah-kadapa-andhra-pradesh": "kadapa",
	"kolluru-andhra-pradesh": "kollur",
	"ambasamutram": "ambasamudram",
	"ambasamudram-tamil-nadu": "ambasamudram",
	"malliakarai": "malliakkarai",
	"baharampur": "berhampore",
	"kosi": "kosi-kalan",
	"mandangad-sangli": "mandangad",
	"reengus-rajasthan": "ringas",
	"reengus": "ringas",
	"ashoknagar": "ashoknagar-madhya-pradesh",
	"balarampuram": "balaramapuram",
	"dholasa": "dolasa",
	"kamalapuram-telangana": "kamalapuram",
	"chhota-udaipur": "chhota-udepur",
	"pamarru-krishna-district": "pamarru",
	"lakhanpur-jammu": "lakhanpur",
	"faizpur-jalgaon": "faizpur",
	"bhadgaon-jalgaon": "bhadgaon",
	"aroor-tamil-nadu": "aroor",
	"rajapur-ratnagiri": "rajapur",
	"pachora-maharashtra": "pachora",
	"dhodar-madhya-pradesh": "dodar",
	"raxaul-bazar": "raxaul",
	"bodh-gaya": "bodhgaya",
	"bariya-gujarat": "bariya",
	"soila": "soyla",
	"sirvar": "sirwar",
	"roha-ashtami": "roha",
	"lohara-latur": "lohara",
	"shirgaon-ratnagiri": "shirgaon",
	"vaijapur-aurangabad": "vaijapur",
	"alamuru-achanta": "alamuru",
	"kalwari-uttar-pradesh": "kalwari",
	"jadan-khalsa": "jadan",
	"karjat-ahmednagar": "karjat",
	"ettimadi": "ettimadai",
	"yelagiri-tamil-nadu": "yelagiri",
	"dharmasthala-karnataka": "dharmasthala",
	"baripada-odisha": "baripada",
	"mysore-karnataka": "mysore",
	"thanjavur-thanjavur": "thanjavur",
	"vikasnagar-uttarakhand": "vikasnagar",
	"kushinagar-uttar-pradesh": "kushinagar",
	"falakata-west-bengal": "falakata",
	"mohania-bihar": "mohania",
	"manali-manali-himachal-pradesh": "manali",
	"malur-karnataka": "malur",
	"karimnagar-telangana": "karimnagar",
	"naugachia": "naugachhia",
	"yamuna-nagar": "yamunanagar",
	"basi": "dera-bassi",
	"jaisalmer-rajasthan": "jaisalmer",
	"jaisalmer-jaisalmer": "jaisalmer",
	"peruvamthanam": "peruvanthanam",
	"vmchatram": "v-m-chatram",
	"nashik-maharashtra": "nashik",
	"anakara": "anakkara",
	"irrikkur": "irikkur",
	"canacona-canacona": "canacona",
	"ooty-tamil-nadu": "ooty",
	"pardi-rj": "pardi",
	"chamrajnagar": "chamarajanagar",
	"barawara-rajasthan": "barawara",
	"dabhole-maharashtra": "dabhole",
	"pollachi-tamil-nadu": "pollachi",
	"loni-ghaziabad": "loni",
	"bilaspur-himachal-pradesh": "bilaspur",
	"dimapur-assam": "dimapur",
	"birpara-west-bengal": "birpara",
	"sanna": "sannanallur",
	"vijaywada": "vijayawada",
	"vijayawada-andhra-pradesh": "vijayawada",
	"tirupati-tirupati": "tirupati",
	"tirupati-andhra-pradesh": "tirupati",
	"vishakhapatnam": "visakhapatnam",
	"visakhapatnam-andhra-pradesh": "visakhapatnam",
	"vijayanagaram": "vizianagaram",
	"porumamilla-andhra-pradesh": "porumamilla",
	"rajpur-cg": "rajpur",
	"pathankot-punjab": "pathankot",
	"chandankera-karnataka": "chandankera",
	"tezu-arunachal-pradesh": "tezu",
	"kurnool-andhra-pradesh": "kurnool",
	"ramanathapuram-ramnad-tamil-nadu": "ramanathapuram",
	"alibaug": "alibag",
	"varadarajanpettai-tamil-nadu": "varadarajanpettai",
	"madurai-tamil-nadu": "madurai",
	"chennai-tamil-nadu": "chennai",
	"dhaka-bangladesh": "dhaka",
	"ambala-cantonment": "ambala",
	"ambala-cantt": "ambala",
	"ahmedabad-gujarat": "ahmedabad",
	"pune-maharashtra": "pune",
	"nagpur-maharashtra": "nagpur",
	"mumbai-maharashtra": "mumbai",
	"aurangabad-maharashtra": "aurangabad",
	"kota-rajasthan": "kota",
	"latur-maharashtra": "latur",
	"parbhani-maharashtra": "parbhani",
	"bhusawal-bhusaval-maharashtra": "bhusawal",
	"kukas-rajasthan": "kukas",
	"eral-tamil-nadu": "eral",
	"arvi-malegaon": "arvi",
	"bhopal-madhya-pradesh": "bhopal",
	"alirajpur-madhya-pradesh": "alirajpur",
	"haridwar-uttarakhand": "haridwar",
	"vadodara-baroda": "vadodara",
	"vadodara-gujarat": "vadodara",
	"handiaya": "barnala-rank",
	"handiaya-punjab": "barnala-rank",
	"varanasi-benaras": "varanasi",
	"varanasi-varanasi": "varanasi",
	"guwahati-assam": "guwahati",
	"anantapur-anantapur": "anantapur",
	"rank-rajamundry-ii": "rajamundry-ii",
	"othakadai-madurai": "othakadai",
	"manur-tamil-nadu": "manur",
	"mattanur": "mattannur",
	"mcleodganj": "mcleod-ganj",
	"mauli": "mavli",
	"mirzapur-uttar-pradesh": "mirzapur",
	"morvi": "morbi",
	"morvi-gujarat": "morbi",
	"mount-abu-rajasthan": "mount-abu",
	"mukkamala": "mukka"
}
